// src/pages/admin/Usuarios.js
import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../context/AuthContext'
import { ROLES_LABELS, ROLES_COLORS } from '../../lib/supabase'

export default function Usuarios() {
  const { profile } = useAuth()
  const [usuarios, setUsuarios] = useState([])
  const [loading, setLoading] = useState(true)
  const [modalRol, setModalRol] = useState(null) // { id, rol }
  const [saving, setSaving] = useState(false)

  useEffect(() => { loadUsuarios() }, [])

  async function loadUsuarios() {
    setLoading(true)
    const { data } = await supabase.from('profiles').select('*').order('nombre')
    setUsuarios(data ?? [])
    setLoading(false)
  }

  async function updateRol() {
    if (!modalRol) return
    setSaving(true)
    await supabase.from('profiles').update({ rol: modalRol.rol }).eq('id', modalRol.id)
    setSaving(false); setModalRol(null); loadUsuarios()
  }

  async function toggleActivo(u) {
    if (u.id === profile.id) return alert('No podés desactivar tu propia cuenta')
    await supabase.from('profiles').update({ activo: !u.activo }).eq('id', u.id)
    loadUsuarios()
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">👥 Usuarios & Permisos</div>
          <div className="page-subtitle">Gestión de accesos al sistema</div>
        </div>
      </div>

      <div className="card">
        <div style={{ marginBottom: 12, padding: '10px 14px', background: 'var(--dark-50)', borderRadius: 8, fontSize: 13, color: 'var(--dark-600)' }}>
          💡 Para agregar usuarios nuevos, creá la cuenta desde Supabase Auth y aparecerá aquí automáticamente.
        </div>
        <div className="table-wrap">
          {loading
            ? <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner spinner-dark" style={{ margin: 'auto' }} /></div>
            : (
              <table>
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Email</th>
                    <th>Rol</th>
                    <th>Estado</th>
                    <th>Miembro desde</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {usuarios.map(u => (
                    <tr key={u.id}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <div style={{
                            width: 32, height: 32, borderRadius: '50%', background: ROLES_COLORS[u.rol] ?? '#6366f1',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            color: 'white', fontSize: 12, fontWeight: 700, flexShrink: 0
                          }}>
                            {u.nombre?.[0]}{u.apellido?.[0]}
                          </div>
                          <div>
                            <div style={{ fontWeight: 600 }}>{u.nombre} {u.apellido}</div>
                            {u.id === profile.id && <div style={{ fontSize: 11, color: 'var(--brand-600)' }}>Tú</div>}
                          </div>
                        </div>
                      </td>
                      <td>{u.email}</td>
                      <td>
                        <span className="badge" style={{ background: ROLES_COLORS[u.rol] + '20', color: ROLES_COLORS[u.rol] }}>
                          {ROLES_LABELS[u.rol] ?? u.rol}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${u.activo ? 'badge-green' : 'badge-gray'}`}>
                          {u.activo ? 'Activo' : 'Inactivo'}
                        </span>
                      </td>
                      <td>{new Date(u.created_at).toLocaleDateString('es')}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn btn-secondary btn-sm" onClick={() => setModalRol({ id: u.id, rol: u.rol })}>
                            Cambiar rol
                          </button>
                          {u.id !== profile.id && (
                            <button className={`btn btn-sm ${u.activo ? 'btn-ghost' : 'btn-secondary'}`} onClick={() => toggleActivo(u)}>
                              {u.activo ? 'Desactivar' : 'Activar'}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          }
        </div>
      </div>

      {/* Roles info card */}
      <div className="card mt-6">
        <div className="card-title" style={{ marginBottom: 16 }}>Descripción de roles</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 10 }}>
          {Object.entries(ROLES_LABELS).map(([key, label]) => (
            <div key={key} style={{ padding: '10px 14px', borderRadius: 8, border: '1px solid var(--dark-200)', display: 'flex', gap: 10, alignItems: 'center' }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: ROLES_COLORS[key], flexShrink: 0 }} />
              <div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>{label}</div>
                <div style={{ fontSize: 11, color: 'var(--dark-500)' }}>
                  {key === 'admin' && 'Acceso completo al sistema'}
                  {key === 'capataz' && 'Agro, animales y cultivos'}
                  {key === 'veterinario' && 'Salud animal y vacunas'}
                  {key === 'comercial' && 'Clientes y ventas'}
                  {key === 'finanzas' && 'Pagos, gastos e ingresos'}
                  {key === 'tecnico_telecom' && 'Instalaciones y mantenimiento'}
                  {key === 'construccion' && 'Obras y materiales'}
                  {key === 'inversionista' && 'Solo lectura de reportes'}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal cambio de rol */}
      {modalRol && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModalRol(null)}>
          <div className="modal" style={{ maxWidth: 360 }}>
            <div className="modal-header">
              <div className="modal-title">Cambiar rol</div>
              <button className="btn btn-ghost btn-icon" onClick={() => setModalRol(null)}>✕</button>
            </div>
            <div className="form-group">
              <label className="form-label">Nuevo rol</label>
              <select className="form-select" value={modalRol.rol} onChange={e => setModalRol(m => ({ ...m, rol: e.target.value }))}>
                {Object.entries(ROLES_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setModalRol(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={updateRol} disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
